import { api } from './client';

/**
 * Background-job health (admin) — GET /api/admin/jobs. In-memory snapshot of
 * each job's last run (nightly sync, backups, retention…): resets on API
 * restart, durable history stays in the container logs.
 */
export interface JobStatusDto {
  jobName: string;
  lastRunUtc: string;
  succeeded: boolean;
  errorMessage: string | null;
}

export const jobsApi = {
  list: () => api.get<JobStatusDto[]>('/admin/jobs'),
};
